<nb-card>
    <nb-menu [items]="menu" (click)="close()"></nb-menu>
</nb-card>